<script>
export default {
  data () {
    return {
      isReloading: null
    }
  },
  async created () {
    await this.serviceWorkerRegister()
  },
  methods: {
    async confirmUpdate (waitingWorker) {
      this.$buefy.dialog.confirm({
        canCancel: false,
        confirmText: 'Install Update',
        hasIcon: true,
        icon: 'wrench',
        message: 'An update is available.',
        onConfirm: () => waitingWorker.postMessage({ action: 'skipWaiting' }),
        title: 'Install Update',
        type: 'is-primary'
      })
    },
    async serviceWorkerRegister () {
      if (navigator && navigator.serviceWorker) {
        navigator.serviceWorker.register('service-worker.js').then(async (registration) => {
          registration.addEventListener('updatefound', () => {
            const installingWorker = registration.installing
            installingWorker.addEventListener('statechange', () => {
              if (installingWorker.state === 'installed') {
                this.confirmUpdate(registration.waiting)
              }
            })
          })
        })
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (!this.isReloading) {
            this.isReloading = true
            window.location.reload()
          }
        })
      }
    }
  }
}
</script>
